// extracted by mini-css-extract-plugin
module.exports = {"loan-summary":"LoanSummary_loan-summary__iEy_N"};